import script from "./CMySkills.vue?vue&type=script&setup=true&lang=ts"
export * from "./CMySkills.vue?vue&type=script&setup=true&lang=ts"

import "./CMySkills.vue?vue&type=style&index=0&id=745bafd0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-745bafd0"]])

export default __exports__